import * as workerTimers from 'worker-timers';
import checkSubscriptionSession, {
  ICheckSubscriptionSessionResponse,
  ICheckSubscriptionSessionSuccessResponse,
} from 'lib/api/subscription';
import {getLoginId} from 'lib/utils';
import {t} from 'lib/i18n';

interface Props {
  isSubscriptionVod: boolean;
  vodUrl: string;
  streamerId: string;
  titleNo: number;
  fileOrder: number;
}

const SESSION_INTERVAL_MS = 60000; // 60초
let _intervalId: number | null = null;

const useSubscriptionSession = ({
  isSubscriptionVod,
  vodUrl,
  streamerId,
  titleNo,
  fileOrder,
}: Props) => {
  const loginId = getLoginId();

  const setSessionInterval = () => {
    clearSessionInterval();
    _intervalId = workerTimers.setInterval(
      validateSession,
      SESSION_INTERVAL_MS,
    );
  };

  const validateSession = async () => {
    try {
      const promise = await checkSession();

      if (!handleCheckSession(promise)) {
        const msg = promise.data && promise.data.message;
        setErrorSession(msg);
        return false;
      }
      return true;
    } catch {
      setErrorSession();
      return false;
    }
  };

  const handleCheckSession = (
    res: ICheckSubscriptionSessionResponse,
  ): res is ICheckSubscriptionSessionSuccessResponse => {
    if (!res || (res && Number(res.result) !== 1)) {
      // 세션 에러
      return false;
    }

    return true;
  };

  const clearSessionInterval = () => {
    if (!_intervalId) {
      return;
    }

    workerTimers.clearInterval(_intervalId);
  };

  const setErrorSession = (
    msg = t(
      '구독팬 전용 다시보기에서는 편집 VOD 만들기\n기능을 이용할 수 없습니다.',
    ),
  ) => {
    clearSessionInterval();

    alert(msg);
    window.history.back();
    return;
  };

  const checkSession = () => {
    return checkSubscriptionSession({
      type: 'vod',
      strm_id: streamerId,
      title_no: titleNo,
      url: vodUrl,
      file_order: fileOrder,
    });
  };

  const startSessionTracking = async () => {
    if (!isSubscriptionVod || (isSubscriptionVod && loginId !== streamerId))
      return Promise.reject({result: -1});

    setSessionInterval();
    return await validateSession();
  };

  const handlers = {
    startSessionTracking,
  };
  return {...handlers};
};

export default useSubscriptionSession;
